/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class InlineEditCurrencyDirective {
    public restrict = 'E';
    public scope;
    public template;

    public currentValue;
    public disableField = false;

    constructor(private $timeout: any) {
        this.restrict = 'E';
        this.scope = {
            value: '=',
            saveFunc: '&?',
            orgCurrency: '=',
            label: '@?',
            isDisabled: '=?',
            canEdit: '=?' 
        };

        this.template = `
            <md-input-container class="d-flex">
                <label>{{label}} in ({{orgCurrency}})</label>
                <input ng-model="value" ng-click="edit()" ng-blur="doneEdit()" ng-keydown="isNumberKey($event);", ng-disabled="canEdit == false">
            </md-input-container>
        `;
        /*<div>
                <div class="col-sm-4">
                    <span ng-click="edit()", ng-bind="value + ' ' + orgCurrency"></span>
                    
                    <input class="form-control", type="text", ng-model="value", ng-keydown="isNumberKey($event);", ng-blur="doneEdit()">
                    <span class="material-input"></span>
                </div>
                <div class="col-sm-2">
                    <a><i class="material-icons", ng-mousedown="undo()">undo</i></a>
                </div>
            </div> */
    }


    public link($scope: any, $element: any, attrs: any): any {
        // need to create a cleaner selection of input elements.
        // var inputElement: any = angular.element(angular.element(
        //     angular.element($element.children()[0]).children()[0]).children()[1]);
        // $element.addClass('inline-edit-text');
        // $scope.editing = false;

        $scope.isNumberKey = function (evt: any): any {
            var key: any = evt.keyCode;
            key = String.fromCharCode(key);
            var regex: any = /[0-9]|\./;
            if (evt.keyCode === 8 || evt.keyCode === 46 || evt.keyCode === 110 || evt.keyCode === 37 || evt.keyCode === 39 || evt.keyCode === 190 || evt.keyCode >= 96 && evt.keyCode <= 105) {
                evt.returnValue = true;
            } else {
                if (!regex.test(key)) {
                    evt.returnValue = false;
                    if (evt.preventDefault) {
                        evt.preventDefault();
                    }
                }
            }

        };


        $scope.edit = function (): any {
            this.currentValue = $scope.value;
        };

        $scope.doneEdit = function (): any {
            var newValue: any = $scope.value;
            var saveObj: any = {
                old: this.currentValue,
                new: newValue,
                model: attrs.value
            };
            if ($scope.saveFunc !== undefined) {
                $scope.saveFunc({args: saveObj});
            }
        };
    }

    public static DirectiveFn($timeout: any): InlineEditCurrencyDirective {
        return new InlineEditCurrencyDirective($timeout);
    }
}

InlineEditCurrencyDirective.DirectiveFn.$inject = ['$timeout'];

angular.module('beneple.global').directive('inlineEditCurrency', InlineEditCurrencyDirective.DirectiveFn);





// WEBPACK FOOTER //
// ./frontend/scripts/global/directives/inline_edit_currency.directive.ts